<div class='evo-masonry-grid__image-wrapper' style=(state.aspectRatio && [`--default-aspect-ratio: ${state.aspectRatio}`, `--default-width: ${state.width}`, `--default-height: ${state.height}`])>
  <img ...input class=['evo-masonry-grid__image', input.class] on-load('handleLoad') data-loaded=state.loaded.toString()>
  <div class='evo-masonry-grid__image-scrim'/>
</div>